import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Shop from "../../Services/shopServices";
import { Button } from "primereact/button";
import { AuthContext } from "../../Auth/Context/AuthContext";
import callApi from "../../helpers/callApi";
import { message } from "antd";
import AreaUnit from "../../Components/AreaUnit";
import USDFigure from "../../Components/USDFigure";
import AFNFigure from "../../Components/AFNFigure";
import TitleHeader from "../accounts/Components/TitleHeader";
function ShopDetails(props) {
  const shopId = useParams().id;
  const { user } = useContext(AuthContext);
  const [shop, setShop] = useState();
  const [shopContracts, setShopContracts] = useState();
  const [shopkeepers, setShopkeepers] = useState();
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [payments, setPayments] = useState([]);
  const [rents, setRents] = useState([]);
  const [endDate, setEndDate] = useState();
  const [reason, setReason] = useState();
  const [errorMessage, setErrorMessage] = useState();
  const navigate = useNavigate();
  const getShop = async () => {
    setLoading(true);
    await Shop.getOne(shopId)
      .then((data) => {
        setShop(data.data);
        setLoading(false);
      })
      .catch((err) => {
        setError(true);
        setLoading(false);
        console.log(err);
      });
  };
  const associateShopkeeper = () => {
    navigate("/add-contract", { state: { shop } });
  };
  const addRent = () => {
    navigate("/add-rent", { state: { shop } });
  };
  const getRents = () => {
    Shop.getRents(shopId)
      .then((response) => {
        console.log("_____ shop rents", response.data);
        setRents(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const addMaintenance = () => {
    navigate("/add-rent", { state: { shop } });
  };
  const getContracts = async () => {
    await callApi(
      `shop-contracts/building-shop-contracts/?shopId=${shopId}&branchId=${user.branchId}`
    )
      .then((response) => {
        setShopContracts(response.data);
      })
      .catch((error) => {
        console.log("__ error", error);
      });
  };
  const getPayments = async () => {
    await callApi(
      `payments/shop-payments/?shopId=${shopId}&branchId=${user.branchId}`
    )
      .then((response) => {
        setPayments(response.data);
      })
      .catch((error) => {
        console.log("__ error Payments", error);
      });
  };
  const getShopShopkeepers = () => {
    Shop.getAllShopkeepers(shopId)
      .then((response) => {
        setShopkeepers(response.data);
      })
      .catch((err) => console.log("error", err));
  };
  useEffect(() => {
    getShop();
    if (shopId) {
      getPayments();
      getContracts();
      getShopShopkeepers();
      getRents();
    }
  }, []);

  const endContract = async (item) => {
    if (item.state !== "ACTIVE")
      return setErrorMessage("Contract is already Cancelled");
    setLoading(true);
    const data = {
      ...item,
      cancelledDate: endDate,
      cancellationReason: reason,
    };
    await Shop.cancellContract(data)
      .then((response) => {
        setErrorMessage("");
        setLoading(false);
        getContracts();
      })
      .catch((error) => {
        console.log("___ error", error);
        setLoading(false);
      });
  };
  return (
    <>
      {loading && (
        <div id="global-loader">
          <div class="whirly-loader"> </div>
        </div>
      )}
      {shop && (
        <div class="page-wrapper">
          <div class="content">
            <TitleHeader title="Shop Details" />

            <div class="row">
              <div class="col-lg-8 col-sm-12">
                <div class="card">
                  <div class="card-body">
                    <div class="bar-code-view w-100">
                      <a
                        class="printimg"
                        onClick={() =>
                          message.warning("This feature will be added later...")
                        }
                      >
                        <img src="/assets/img/icons/printer.svg" alt="print" />
                      </a>
                      Active Shopkeeper:
                      <ul>
                        <li style={{ color: "green" }}>
                          {shop?.shopkeeperName || "No Shopkeeper"}
                        </li>
                        <li style={{ color: "green" }}>
                          {shop?.secondShopkeeperName}
                        </li>
                      </ul>
                    </div>
                    <div class="productdetails">
                      <ul class="product-bar">
                        <li>
                          <h4>Name</h4>
                          <h6>{shop?.name} </h6>
                        </li>
                        <li>
                          <h4>Shop Number</h4>
                          <h6>{shop?.shopNumber} </h6>
                        </li>
                        <li>
                          <h4>Phone Number</h4>
                          <h6>{shop?.phone} </h6>
                        </li>
                        <li>
                          <h4>Revenue Account Name</h4>
                          <h6>{shop?.revenueAccountName} </h6>
                        </li>
                        <li>
                          <h4>Area</h4>
                          <h6>
                            <AreaUnit area={shop?.area} />
                          </h6>
                        </li>
                        <li>
                          <h4>Maintenance Fee</h4>
                          <h6>${shop?.monthlyMaintenanceFee}</h6>
                        </li>
                        <li>
                          <h4>Monthly Rent</h4>
                          <h6>${shop?.monthlyRent}</h6>
                        </li>
                        <li>
                          <h4>Occupied</h4>
                          <h6>{shop?.isOccupied ? "Yes" : "No"}</h6>
                        </li>
                        <li>
                          <h4>Floor</h4>
                          <h6>{shop?.buildingFloorFloorNumber}</h6>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-sm-12">
                <div class="card">
                  <Button
                    label="Make a Contract"
                    severity="secondary"
                    onClick={associateShopkeeper}
                  />
                  <br />
                  <Button
                    label="Add Rent"
                    severity="secondary"
                    onClick={addRent}
                  />
                  <br />
                  <Button
                    label="Add Maintenance"
                    severity="secondary"
                    onClick={addMaintenance}
                  />
                </div>
              </div>
              <h1>Shopkeepers</h1>
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <th>Name</th>
                    <th>Phone</th>
                    <th>Address</th>
                  </thead>
                  <tbody>
                    {shopkeepers?.map((item) => (
                      <tr>
                        <td>{item.shopkeeperName}</td>
                        <td>{item.shopkeeperPhone}</td>
                        <td>{item.shopkeeperAddress}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <h1>Payments</h1>
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <th>Transaction</th>
                    <th>Date</th>
                    <th>Account</th>
                    <th>Shop</th>
                    <th>Currency</th>
                    <th>Amount</th>
                    <th>Memo</th>
                  </thead>
                  <tbody>
                    {payments?.map((item) => (
                      <tr>
                        <td>{item.name}</td>
                        <td>{item.date}</td>
                        <td>{item.accountName}</td>
                        <td>{item.shopName}</td>
                        <td>{item.currencyName}</td>
                        <td>
                          {item.currencyName === "USD" ? (
                            <USDFigure amount={item.amount} />
                          ) : (
                            <AFNFigure amount={item.amount} />
                          )}
                        </td>
                        <td>{item.memo}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <h1>Contracts</h1>
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <th>Contract</th>
                    <th>Shopkeeper</th>
                    <th>Contract Type</th>
                    <th>Contract Date</th>
                    <th>Contract Start Date</th>
                    <th>Contract End Date</th>
                    <th>Status</th>
                    <th>Note</th>
                    <th>End Contract</th>
                  </thead>
                  <tbody>
                    {shopContracts?.map((item) => (
                      <tr>
                        <td>{item.name}</td>
                        <td>{item.shopkeeperName}</td>
                        <td>{item.contractType}</td>
                        <td>{item.contractDate}</td>
                        <td>{item.startDate}</td>
                        <td>{item.endDate}</td>
                        <td>{item.state}</td>
                        <td>{item.note}</td>
                        {!item.endDate && (
                          <td>
                            <button
                              type="button"
                              class="btn btn-secondary"
                              data-toggle="modal"
                              data-target="#exampleModal"
                              data-whatever="@mdo"
                              onClick={() => setErrorMessage("")}
                            >
                              End Contract
                            </button>

                            <div
                              class="modal fade"
                              id="exampleModal"
                              tabindex="-1"
                              role="dialog"
                              aria-labelledby="exampleModalLabel"
                              aria-hidden="true"
                            >
                              <div class="modal-dialog" role="document">
                                <div class="modal-content">
                                  <div class="modal-header">
                                    <h5
                                      class="modal-title"
                                      id="exampleModalLabel"
                                    >
                                      Contract Cancellation
                                    </h5>
                                    <button
                                      type="button"
                                      class="close"
                                      data-dismiss="modal"
                                      aria-label="Close"
                                    >
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div class="modal-body">
                                    <p style={{ color: "red" }}>
                                      {errorMessage}
                                    </p>
                                    <form>
                                      <div class="form-group">
                                        <label
                                          for="date"
                                          class="col-form-label"
                                        >
                                          Date:
                                        </label>
                                        <input
                                          type="date"
                                          class="form-control"
                                          id="date"
                                          onChange={(e) =>
                                            setEndDate(
                                              new Date(
                                                e.target.value
                                              ).toISOString()
                                            )
                                          }
                                        />
                                      </div>
                                      <div class="form-group">
                                        <label
                                          for="message-text"
                                          class="col-form-label"
                                        >
                                          Reason:
                                        </label>
                                        <textarea
                                          class="form-control"
                                          id="message-text"
                                          onChange={(e) =>
                                            setReason(e.target.value)
                                          }
                                        ></textarea>
                                      </div>
                                    </form>
                                  </div>
                                  <div class="modal-footer">
                                    <button
                                      type="button"
                                      class="btn btn-secondary"
                                      data-dismiss="modal"
                                    >
                                      Close
                                    </button>
                                    <button
                                      type="button"
                                      class="btn btn-primary"
                                      onClick={() => endContract(item)}
                                    >
                                      Save
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default ShopDetails;
